import {ValidatorFn} from 'features/search/validators';

export const orgnrValidator: ValidatorFn = val => {
  return val.match(/^\d{9}$/) ? {valid: true} : {valid: false, error: 'invalid'};
};
